
import Toll from '../../../services/toll'
import Contracts from '../../../services/contracts'
import TransferShipperValue from './transfer-shipper-value'
import Auth from '../../../services/auth'
import {centss} from '../../../filters/number'
import Account from '../../../services/account'
import ModalReceiptTransfer from './modal-receipt-transfer.vue'
import MessageDialog from '../../../components/message-dialog';

export default{
  components: {MessageDialog},
  data() {
    return {
      loading:undefined,
      search:undefined,
      status:'',
      userReceive:undefined,
      messageError:undefined,
      taxIdNumber: undefined,
      step: 1,
      transfValue:undefined,
      contract:undefined,
      contracts: undefined, // lista de contratos que podem ser creditados
      contractCred: undefined,
      checkBalance: false,
      favored: {},
      showModalReceipt: false,
      orderData: {},
    }
  },
  computed: {
    fomatedValue() {
      return centss(this.transfValue);
    },
    checkValue(){
      return !this.transfValue || this.transfValue === 0
    },
    checkTransferValue(){
      return this.transfValue * 1.02 > this.contractData.currentBalance.currentTotalBalance;
    },
    contratoOrigem(){
      return this.$route.params.contract.contractId
    },
    fomatedTax() {
      // TODO CARREGAR VALOR DA TAXA DINAMICAMENTE
      return centss(this.transfValue*0.02);
    },
    fomatedTotal() {
      // TODO CARREGAR VALOR DA TAXA DINAMICAMENTE
      return centss(this.transfValue*1.02);
    },
    contractData() {
      return this.$route.params.contract;
    },
    currentUser() {
      return Auth.currentUser;
    }
  },
  methods: {
    nextStep(){
      switch(this.step){
        case 1:
          if(!this.userReceive){
            this.messageError = 'Informe o CNPJ';
            this.status = 'ERROR';
            return ;
          }
    console.log(this.contractCred, "contractCred");
            console.log(this.userReceive, "userReceive");
          this.favored = {

            company: this.contractCred.companyName,
            cnpj: this.userReceive.taxIdNumber,
            plan: this.contractCred.planName
          };
          this.step += 1;
          break;
        case 2:
          if(!this.transfValue || this.transfValue <= 0){
            this.messageError = 'Informe o valor a ser creditado';
            this.status = 'ERROR';
            return ;
          }
          this.step += 1;
          break;
        default:
          this.step += 1;

      }
    },

    filter(){
      let vm = this;
        this.status = 'EMPTY';
        this.transfValue = 0;

        this.$validator.validateAll().then(r => {
          const searchTaxId = this.search.replace(/[.\-\/]/g, "").toUpperCase();
          this.loading = Account.getUserSimple(searchTaxId).then((response)=>{
            let vm = this;
            this.userReceive = response;
            console.log(this.userReceive, "response user receive")
            this.status = 'FOUND';
            return Contracts.getContractListSimple(searchTaxId, this.currentUser.taxIdNumber, 0).then(res2 => {
              vm.contracts = res2.contracts.filter(o => {
                if (this.currentUser.taxIdNumber == searchTaxId) {
                  debugger
                  console.log(o, "o 1")
                  console.log(this.currentUser, "current user");
                  if(o.contractId != this.currentUser.onlyOneContract) {
                    return o;
                  }
                } else {
                  if(o.planId == 6 || o.planId == 8) {
                    return o;
                  }
                }
              });
              if (vm.contracts[0].currentBalance != null) {
                this.checkBalance = true;
              }
            });
          }).catch(error=>{

            MessageDialog.show({
              title: 'Falha',
              message: 'Não foi encontrado nenhum contrato para receber o crédito da transferência.'
            })
            this.messageError = error.data.status.message;
            this.status = 'ERROR';
          });

        }).catch(err => {
          this.status = 'ERROR';
          this.messageError = 'CNPJ inválido';
        });


    },
    transfer(){
      let vm =  this;
      this.loading = Toll.transferirEmbarcador({contractIdCred: vm.contractCred.contractId, contractIdDeb: vm.contratoOrigem, transferValue: vm.transfValue}).then( res => {
        this.orderData = {
          cnpjCred: this.userReceive.taxIdNumber,
          cnpjDeb: this.currentUser.taxIdNumber,
          planCred: this.contractCred.planName,
          planDeb: this.contractData.plan.name,
          orderId: res.transfer.orderId
        };
        this.step += 1;
        // this.$router.push({name:'receipt-credit', params:{orderId: res.transfer.orderId}});

      }).catch(err => {
        console.log(err);
        this.messageError = err.data.status.message;
        this.status = 'ERROR';
      });

      this.$store.dispatch('loading', this.loading);
    },
    modalReceipt() {
      // this.showModalReceipt = true;
      this.$nextTick(() => {
        $('#modal-receipt-transfer').modal();
      });
    },
    close(fn) {
      $('#modal-receipt-transfer').modal('hide');
      this.showModalReceipt = fn;
    },
  },
  components:{
    TransferShipperValue, ModalReceiptTransfer
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/shipper/transfer-shipper.js



// WEBPACK FOOTER //
// ./src/pages/account/shipper/transfer-shipper.js